import { DocsView } from '@/models/doc'
import { DocType } from '@/models/interfaces'

interface OptionData {
  docType: DocType
  name: string
  click: () => void
  isActive: () => boolean
}

export class DocsFilterTypeView {
  private _view: DocsView

  private _visible: boolean = false

  public options: OptionData[] = []

  constructor(view: DocsView) {
    this._view = view

    this.options = [
      this._createOptionData('book', 'Books'),
      this._createOptionData('article', 'Articles'),
      this._createOptionData('podcast_episode', 'Podcasts'),
    ]
  }

  /**
   * Create one filter option for `docType`.
   */
  private _createOptionData(docType: DocType, name: string): OptionData {
    return {
      docType: docType,
      name: name,
      click: (): void => this._optionClick(docType),
      isActive: (): boolean => this._view.acceptsDocType(docType),
    }
  }

  private _optionClick(docType: DocType): void {
    void this._view.toggleDocType(docType)
  }

  /**
   * Return true if the filter options menu is visible.
   */
  public get visible(): boolean {
    return this._visible
  }

  /**
   * Hide filter options menu.
   *
   * We use this method along with click-outside directive.
   */
  public hide(): void {
    this._visible = false
  }

  /**
   * Toggle filter options menu visibility.
   */
  public toggleMenu(): void {
    this._visible = !this._visible
  }
}
